export const TAB = {
    jobs: 'jobs',
    projects: 'projects',
};

export const TAB_LABEL = {
    [TAB.jobs]: 'All Jobs',
    [TAB.projects]: 'All Projects',
};
